import { Formik } from 'formik'
import React, { useEffect, useState, useRef } from 'react'
import StepItem from '../../molecules/StepItem/StepItem'
import BozzaDigitale from './Steps/BozzaDigitale/BozzaDigitale'
import IndirizzoSpedizione from './Steps/IndirizzoSpedizione/IndirizzoSpedizione'
import ModalitaSpedizione from './Steps/ModalitaSpedizione/ModalitaSpedizione'
import DocumentoTrasporto, { _uploadDocumenti } from './Steps/DocumentoTrasporto/DocumentoTrasporto'
import ModalitaPagamento from './Steps/ModalitaPagamento/ModalitaPagamento'
import * as yup from 'yup'
import { api } from '../../../utils'
import { ORDINI } from '../../../utils/endpoint'
import _ from 'lodash'
import useTrans from '../../../hooks/useTrans'
import useLocalStorage from '../../../hooks/useLocalStorage'
import { useRouter } from 'next/router'
import { handleScrollRef } from '../../../utils/safe'
import * as Sentry from '@sentry/browser'
import { trackingGAEvent } from '../../../utils/gtm'

api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

const FormCheckout = ({
  pushPayload,
  service_gift,
  carrello_main,
  setIsSubmit,
  promoCodeErrorMessage,
  promoCodeAlertMessage,
}) => {
  const isMerceNeutra = carrello_main.personalizzazioni_carrello?.length > 0 ? false : true
  const checkoutRapido = carrello_main.tipologia === 'PREVENTIVO'
  const step_modalita_pagamento = service_gift ? (!isMerceNeutra ? 3 : 2) : !isMerceNeutra ? 4 : 3
  const [valori_iniziali, setValoriIniziali] = useLocalStorage('VALORI_INIZIALI_SPLIT_CHECKOUT')
  const [step, setStep] = useState(0)
  const [splitCheckout, setSplitCheckout] = useState(null)
  const router = useRouter()
  const indirizzoSpedizioneItemRef = useRef()
  const carrello_main_id = carrello_main.id

  useEffect(() => {
    if (carrello_main?.ordine?.carrello) {
      valori_iniziali &&
        (setSplitCheckout({ ...valori_iniziali }), setStep(step_modalita_pagamento - 1))
    }
  }, [])

  useEffect(() => {
    pushPayload(null)
  }, [step])

  const StepNumbers = () => {
    return service_gift
      ? {
          indirizzo: 0,
          bozza: 1,
          pagamento: 2,
        }
      : {
          indirizzo: 1,
          bozza: 2,
          pagamento: 3,
        }
  }

  const RecapModalitaPagamento = ({ opzioni_pagamento, id, codice_sconto }) => {
    const t = useTrans()
    const nome_opzione = opzioni_pagamento?.filter((opzione) => opzione?.id === id)[0]
    return (
      <div>
        {codice_sconto && (
          <>
            <p className={`codice-sconto ${promoCodeErrorMessage && 'codice-sconto__error'}`}>
              <>
                {t('Codice sconto')}: {codice_sconto}
              </>
              <br />
              {promoCodeErrorMessage ? <>{t(promoCodeErrorMessage)}</> : null}
              <div className={`${promoCodeAlertMessage && 'codice-sconto__warning'}`}>
                {promoCodeAlertMessage ? <>{t(promoCodeAlertMessage)}</> : null}
              </div>
            </p>
          </>
        )}
        <p>{nome_opzione?.nome ? nome_opzione?.nome : nome_opzione?.descrizione}</p>
      </div>
    )
  }

  const RenderStep = ({ props, service_gift, isMerceNeutra, carrello_main, setIsSubmit }) => {
    const t = useTrans()
    return (
      <>
        {!service_gift && (
          <StepItem
            placeholder={t('Modalità di consegna')}
            setStep={setStep}
            Modificabile={step > 0 ? true : false}
            stepNumber={1}
            recap={
              step > 0 && (
                <p>{props.values.tipo_spedizione !== 'Ritiro' ? 'Spedizione' : 'Ritiro'}</p>
              )
            }
            isDisabled={step < 0 ? true : false}
            open={step === 0 ? true : false}
          >
            <ModalitaSpedizione
              service_gift={service_gift}
              setStep={setStep}
              step={step}
              props={props}
              isMerceNeutra={isMerceNeutra}
              carrello_main={carrello_main}
            />
          </StepItem>
        )}

        <div ref={indirizzoSpedizioneItemRef}></div>
        <StepItem
          placeholder={t(`Indirizzo ${!service_gift ? 'e tipo di Spedizione' : ''}`)}
          setStep={setStep}
          Modificabile={
            props.values.tipo_spedizione !== 'Ritiro'
              ? step > StepNumbers().indirizzo
                ? true
                : false
              : false
          }
          recap={
            step > StepNumbers().indirizzo &&
            props.values.tipo_spedizione !== 'Ritiro' && (
              <div>
                <p>
                  <strong>{props.values.indirizzo?.ragione_sociale}</strong>
                </p>
                <p>
                  {' '}
                  {props.values.indirizzo?.indirizzo +
                    ' ' +
                    props.values.indirizzo?.citta +
                    ' ' +
                    props.values.indirizzo?.cap +
                    ' ' +
                    props.values.indirizzo?.nazione?.nome}
                </p>

                {!service_gift && (
                  <p style={{ marginTop: 10 }}>
                    {props.values?.tipo_spedizione === 'corriere_sipec'
                      ? t('Spedizione con corriere Sipec ed addebito in fattura')
                      : t(`Spedizione con ${props.values?.tipo_spedizione}`)}
                  </p>
                )}
              </div>
            )
          }
          stepNumber={StepNumbers().indirizzo + 1}
          isDisabled={
            props.values.tipo_spedizione !== 'Ritiro'
              ? step < StepNumbers().indirizzo
                ? true
                : false
              : true
          }
          open={step === StepNumbers().indirizzo ? true : false}
        >
          <IndirizzoSpedizione
            setStep={setStep}
            step={step}
            props={props}
            service_gift={service_gift}
            carrello_main={carrello_main}
            handleScroll={() => handleScrollRef(indirizzoSpedizioneItemRef)}
          />
        </StepItem>

        {!service_gift &&
          false && ( // Nascosto momentaneamente anche su sipec
            <StepItem
              placeholder={t('Documento di trasporto')}
              setStep={setStep}
              Modificabile={
                props.values.tipo_spedizione !== 'Ritiro' ? (step > 2 ? true : false) : false
              }
              recap={
                step > 2 && (
                  <div>
                    <p>
                      {props.values.documento_trasporto === 'ts' &&
                        t('Documento di trasporto sipec')}
                      {props.values.documento_trasporto === 'tm' &&
                        t('Documento di trasporto con mia intestazione')}
                    </p>
                  </div>
                )
              }
              stepNumber={3}
              isDisabled={
                props.values.tipo_spedizione !== 'Ritiro' ? (step < 2 ? true : false) : true
              }
              open={step === 2 ? true : false}
            >
              <DocumentoTrasporto
                setStep={setStep}
                step={step}
                props={props}
                carrello_main={carrello_main}
              />
            </StepItem>
          )}
        {!isMerceNeutra && (
          <StepItem
            placeholder={t('Bozza digitale')}
            setStep={setStep}
            Modificabile={step > StepNumbers().bozza ? true : false}
            recap={
              step > 3 && (
                <div>
                  <p>{props.values.email_bozza_digitale}</p>
                </div>
              )
            }
            stepNumber={StepNumbers().bozza + 1}
            isDisabled={step < StepNumbers().bozza ? true : false}
            open={step === StepNumbers().bozza ? true : false}
          >
            <BozzaDigitale
              setStep={setStep}
              step={step}
              props={props}
              carrello_main={carrello_main}
            />
          </StepItem>
        )}

        <StepItem
          placeholder={
            !service_gift ? t('Modalità di pagamento e codice sconto') : t('Modalità di pagamento')
          }
          setStep={setStep}
          recap={
            step > step_modalita_pagamento - 1 && (
              <div>
                <RecapModalitaPagamento
                  opzioni_pagamento={props?.values?.opzioni_pagamento}
                  id={props?.values?.id_modalita_pagamento}
                  codice_sconto={props?.values?.codice_sconto}
                />
              </div>
            )
          }
          Modificabile={step > step_modalita_pagamento - 1 ? true : false}
          stepNumber={step_modalita_pagamento}
          isDisabled={step < step_modalita_pagamento - 1 ? true : false}
          open={step === step_modalita_pagamento - 1 ? true : false}
        >
          <ModalitaPagamento
            Submit={() => props.handleSubmit()}
            setStep={setStep}
            step={step}
            props={props}
            carrello_main={carrello_main}
          />
        </StepItem>
      </>
    )
  }

  const _handleSubmit = ({ params, file_documento }) => {
    // ! Inserire il pushPayload con la risposta
    setIsSubmit(true)
    api
      .post(ORDINI, params, {
        params: {
          lang: router.locale,
        },
      })
      .then((res) => {
        trackingGAEvent(
          'coupon_entry',
          res?.data?.promo_code_error ? 'coupon_ko' : 'coupon_ok',
          params?.codice_sconto
        )
        if (params?.documento_trasporto === 'tm' && file_documento) {
          _uploadDocumenti({
            id: res?.data?.id,
            file_to_upload: file_documento,
          })
            .then(() => setIsSubmit(false))
            .catch((err) => {
              console.log(err)
              setIsSubmit(false)
              Sentry.captureException(err)
            })
          pushPayload(res.data)
        } else {
          pushPayload(res.data)
          setIsSubmit(false)
        }
      })
      .catch((err) => {
        trackingGAEvent('coupon_entry', 'coupon_ko', params?.codice_sconto)
        console.log(err.message)
        setIsSubmit(false)
        Sentry.captureException(err)
        router.push('/cart')
      })
  }
  return (
    <Formik
      enableReinitialize={true}
      initialValues={
        splitCheckout
          ? valori_iniziali
          : {
              tipo_spedizione: service_gift ? 'corriere_sipec' : null,
              tipo_spedizione_id: null,
              indirizzo: null,
              documento_trasporto: 'ts',
              id_modalita_pagamento: null,
              codice_sconto: '',
              carrello_main_id: carrello_main_id,
            }
      }
      onSubmit={(values) => {
        try {
          setValoriIniziali(values)
          values.tipo_spedizione === 'Ritiro'
            ? _handleSubmit({
                params: Object.assign(
                  {},
                  {
                    sistema_pagamento: values.id_modalita_pagamento,
                    modalita_spedizione: values.tipo_spedizione_id,
                    email_bozza_digitale: values.email_bozza_digitale,
                    carrello: checkoutRapido ? checkoutRapido?.id?.toString() : carrello_main_id,
                    codice_sconto: values.codice_sconto,
                  }
                ),
                file_documento: values?.file_documento ? values?.file_documento : undefined,
              })
            : _handleSubmit({
                params: Object.assign(
                  {},
                  {
                    sistema_pagamento: values.id_modalita_pagamento,
                    modalita_spedizione: values.tipo_spedizione_id,
                    indirizzo: values.indirizzo.id,
                    email: values.email_spedizione,
                    documento_trasporto: values.documento_trasporto,
                    email_bozza_digitale: values.email_bozza_digitale,
                    carrello_main_id: values.carrello_main_id,
                    note: values.note_spedizione ? values.note_spedizione : null,
                    porto: values.porto_id,
                    vettore: values.vettore_id,
                    carrello: checkoutRapido ? checkoutRapido?.id?.toString() : carrello_main_id,
                    altro_vettore: values?.altro_vettore ? values?.altro_vettore : undefined,
                    codice_sconto: values.codice_sconto,
                  }
                ),
                file_documento: values?.file_documento ? values?.file_documento : undefined,
              })
        } catch (error) {
          console.log(error)
          Sentry.captureException(error)
        }
      }}
      validationSchema={() =>
        yup.lazy((values) => {
          if (values.tipo_spedizione === 'Ritiro') {
            return yup.object().shape({
              tipo_spedizione: yup.string().required(),
              id_modalita_pagamento: yup.number().required(),
            })
          } else {
            if (!isMerceNeutra) {
              return yup.object().shape({
                tipo_spedizione: yup.string().required(),
                indirizzo: yup.object(),
                email_bozza_digitale: yup
                  .string()
                  .email('Il formato inserito non corrisponde ad una e-mail')
                  .nullable(),
                email_spedizione: yup
                  .string()
                  .email('Il formato inserito non corrisponde ad una e-mail')
                  .nullable()
                  .required(),
                documento_trasporto: yup.string(),
                id_modalita_pagamento: yup.number(),
              })
            } else {
              return yup.object().shape({
                tipo_spedizione: yup.string().required(),
                indirizzo: yup.object(),
                email_spedizione: yup
                  .string()
                  .email('Il formato inserito non corrisponde ad una e-mail')
                  .nullable()
                  .required(),
                documento_trasporto: yup.string(),
                id_modalita_pagamento: yup.number(),
              })
            }
          }
        })
      }
    >
      {(props) => (
        <div>
          <RenderStep
            setIsSubmit={setIsSubmit}
            props={props}
            service_gift={service_gift}
            isMerceNeutra={isMerceNeutra}
            carrello_main={carrello_main}
          />
          {/* {props.isValid && step > step_modalita_pagamento - 1 && (
            <Button
              label="Crea ordine"
              variant="primary"
              size="large"
              type="submit"
              onClick={() => props.handleSubmit()}
            />
          )} */}
          {process.env.NODE_ENV == 'development' && (
            <>
              {/* <button onClick={() => setMerceNeutra(!isMerceNeutra)}>
              {isMerceNeutra ? 'Disattiva' : 'Attiva'} il "Solo Merce Neutra" [Fini di Test]
            </button> */}
              <br />
              <button type="submit" onClick={() => console.log(props.values)}>
                Controlla payload
              </button>
              <br />
              <button type="submit" onClick={() => props.handleSubmit()}>
                Prova un Submit
              </button>
              <p style={{ color: 'red', marginTop: 20 }}>
                <strong>{JSON.stringify(props.errors, null, 2)}</strong>
              </p>
            </>
          )}
        </div>
      )}
    </Formik>
  )
}

export default FormCheckout
